import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getToolbarUtilityClass(slot: string) {
  return generateUtilityClass('O2Pane', slot);
}

const paneClasses = generateUtilityClasses('O2Pane', ['root', 'selected']);

export default paneClasses;
